module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABTElEQVRYR8WXTUoEMRCFvweKCOIlRtALuBEUN648jcvZzexm6QHEK7gQZQTxGrryJlISSENoaDs/NSYXeF+9V5VUxI6OmZ0Bl8CjpJ8pGe1C38zOgXfgGFhI+v43gCj+ARwBS0mbv4p0daBUPIC5AZjZBfCWW/ngigtAFA+ZH+bYnkbSDNAi3hxBq3gTgJldA681tjdHEMW3wEFp5uORLO4BT/HiCMzsBnj2qLx4DKP4C7APrCWtPK7xrAhG4htJSw/xrAjM7BZ4ipW7is8CmNkJ8AnsAe7iOQAL4KsbQCDsGsHQaF2bcAJiJWntMQlZYziC6HMRJRDhEXJ5B2anYMpiz/egKIIUyAuiGiCOaPNO0AQQIcIyWrUPVvfAuDdaVrNmB5Lp6LeWJxDhSzb8iu4k3c9dVm4O1EK4A8TG7Pc5TZw4Ba6AB0k2FcUvgrmgIV5t4X4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/back.png
// module id = uKWM
// module chunks = 1